const Footer = () => {
  return (    
  <footer className='main-footer'>
      <strong>
        Copyright &copy; 2020
        <a href='http://rendamonitorada.com.br' target='_blank'>
          Wedan Tecnologia e Inovações (WTI)
        </a>
      </strong>
    </footer>);
};

export default Footer;